module.exports = "https://cwa.roocdn.com/_next/static/rider-walker.f7e552d6.png";